import React from 'react';

const BulkAddCategoryModal = ({
  show,
  onClose,
  categoryIds,
  onToggleCategory,
  search,
  onSearchChange,
  categories,
  selectedCount,
  onApply,
  loading,
  message
}) => {
  if (!show) return null;
  const q = (search || '').trim().toLowerCase();
  const filtered = !q ? categories : categories.filter(cat => (cat.name || '').toLowerCase().includes(q));
  return (
    <>
      <div className="modal-backdrop show" style={{ zIndex: 1040 }} />
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1050 }}
        onClick={() => !loading && onClose()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Додати категорії</h5>
              <button type="button" className="close" aria-label="Close" onClick={() => !loading && onClose()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <div className="position-relative d-flex align-items-center mb-2">
                <input
                  type="text"
                  className="form-control pr-4"
                  placeholder="Пошук категорій..."
                  value={search || ''}
                  onChange={e => onSearchChange(e.target.value)}
                />
                {search && (
                  <button
                    type="button"
                    className="btn p-0 border-0 bg-transparent position-absolute"
                    style={{ right: '8px', fontSize: '1.1rem', lineHeight: 1, color: '#6c757d', cursor: 'pointer' }}
                    onClick={() => onSearchChange('')}
                    title="Очистити"
                    aria-label="Очистити"
                  >
                    <i className="bi bi-x" />
                  </button>
                )}
              </div>
              <div className="border rounded p-2" style={{ maxHeight: '260px', overflowY: 'auto' }}>
                {filtered.length === 0 ? (
                  <p className="text-muted small mb-0">{categories.length === 0 ? 'Немає категорій' : 'Нічого не знайдено'}</p>
                ) : (
                  filtered.map(cat => (
                    <div
                      key={cat.id}
                      className="form-check d-flex align-items-center px-2 py-1 rounded"
                      style={{
                        minHeight: '32px',
                        ...(!cat.parentId ? { borderLeft: '4px solid #007bff' } : {})
                      }}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`bulk-cat-${cat.id}`}
                        checked={categoryIds.includes(cat.id)}
                        onChange={() => onToggleCategory(cat.id)}
                        style={{ width: '18px', height: '18px', marginTop: 0, cursor: 'pointer', flexShrink: 0 }}
                      />
                      <label className="form-check-label ml-2 mb-0 flex-grow-1 text-truncate" htmlFor={`bulk-cat-${cat.id}`} style={{ cursor: 'pointer', fontSize: '0.8rem' }} title={cat.name}>
                        {cat.name}
                      </label>
                    </div>
                  ))
                )}
              </div>
              {categoryIds.length > 0 && (
                <p className="small mt-2 mb-0 text-left text-muted">Обрано категорій: {categoryIds.length}</p>
              )}
              <p className="text-muted small mt-2 mb-0 text-left">
                Обрані категорії будуть додані до {selectedCount} обраних товарів (існуючі категорії збережуться).
              </p>
              {message && (
                <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'} mt-3 mb-0`} role="alert">
                  {message.text}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-dark btn-block"
                onClick={onApply}
                disabled={categoryIds.length === 0 || loading}
              >
                {loading ? 'Застосування…' : 'Застосувати'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkAddCategoryModal;
